import { useQuery } from '@tanstack/react-query';
import { learnerKeys } from './learnerKeys';
import * as me from '../../api/me';

/**
 * Loads the learner's course detail. The `id` is the `assignment_id` from the
 * route.
 */
export function useCourse(id: string) {
  return useQuery({
    queryKey: learnerKeys.course(id),
    queryFn: () => me.getCourse(id),
    enabled: !!id,
    retry: (count, err) => {
      const status = (err as { response?: { status?: number } })?.response?.status;
      if (status === 403 || status === 404) return false;
      return count < 2;
    },
  });
}
